// import 'babel-polyfill';
import arrayMutators from 'final-form-arrays';
import axios from 'v1/utils/axios';
import React, { Component } from 'react';
import redirect from 'v1/utils/redirect';
import { Checkbox, Input } from 'semantic-ui-react';
import { FieldArray } from 'react-final-form-arrays';
import { Form, Field } from 'react-final-form';
import Cleave from 'cleave.js/react'; // https://github.com/nosir/cleave.js
import decorator from './decorator';
import error from './errors';

class NewContest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initValues: {
        excluded_from_season_pass: false,
        kind: 'survive',
        published: false,
        season_id: this.props.seasons[0].id,
        season_name: this.props.seasons[0].name,
        image: '',
        defaultEnd: this.props.defaultEnd,
        ends_at: undefined,
        stat_categories: [],
      },
      // published: false,
      create: true,
      coverImage: '',
      requiredAmountSurvive: this.props.requiredAmountSurvive,
      requiredAmountWeekly: this.props.requiredAmountWeekly,
      resourceContest: this.props.resourceContest,
      seasons: this.props.seasons,
      stats: this.props.stats,
      url: this.props.url,
      // validationErrors: {},
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.deletePrize = this.deletePrize.bind(this);
    this.imageUploadHeandler = this.imageUploadHeandler.bind(this);
    this.showCover = this.showCover.bind(this);
  }

  showCover() {
    return (
      <div className="field">
        <img src={this.props.imageUrl} />
      </div>
    );
  }

  imageUploadHeandler(file) {
    this.setState({
      coverImage: file,
    });
  }

  componentWillMount() {
    if (this.state.resourceContest !== undefined) {
      this.setState({
        create: false,
      });
      const data = this.props.resourceContest;

      this.setState({
        initValues: data,
        published: data.published,
      });
    }
  }

  onSubmit(values) {
    const onSuccess = (data) => {
      this.onSuccess(data);
    };
    const onError = (data) => {
      this.onError(data);
    };

    const valuesId = values.id !== undefined;

    if (typeof values.participants_max_count !== 'number') {
      const newMaxPlayers = values.participants_max_count.replace(/[^-0-9]/gi, '');
      values.participants_max_count = parseFloat(newMaxPlayers);
    }

    values.coverImage = this.state.coverImage;

    const formData = new FormData();
    formData.set('contest', JSON.stringify(values));
    formData.append('image', this.state.coverImage);

    if (valuesId) {
      axios
        .put(this.state.url, formData)
        .then((response) => {
          const data = response;
          onSuccess(data);
        })
        .catch((error) => {
          const errors = error.response.data.payload.errors.contest;
          onError(errors);
        });
    } else {
      axios
        .post(this.state.url, formData)
        .then((response) => {
          const data = response;
          onSuccess(data);
        })
        .catch((error) => {
          const errors = error.response.data.payload.errors.contest;
          onError(errors);
        });
    }
  }

  deletePrize(id) {
    if (id !== undefined) {
      axios
        .delete(`${this.props.deletePrizeUrl}/${id}`, {
          contest: id,
        })
        .then((response) => {})
        .catch((error) => {});
    } else {
    }
  }

  onSuccess(data) {
    const url = data.data.location;
    redirect(url);
  }

  render() {
    const { requiredAmountSurvive, requiredAmountWeekly } = this.state;

    return (
      <div>
        <Form
          validate={(values) => {
            const errors = {};
            if (!values.name) {
              errors.name = 'Must be filled';
            }

            if (!values.starts_at) {
              errors.starts_at = 'Must be filled';
            }

            if (!values.ends_at) {
              errors.ends_at = 'Must be filled';
            }

            if (!values.participants_max_count) {
              errors.participants_max_count = 'Must be filled';
            }

            if (typeof values.entry_cost === 'undefined' || values.entry_cost === '$') {
              errors.entry_cost = 'Must be filled';
            }

            if (!values.stat_categories) {
              errors.stat_categories = 'Must be filled';
            }

            if (!values.prize_video_url) {
              errors.prize_video_url = 'Must be filled';
            }

            if (!values.season_id) {
              errors.season_id = 'Must be filled';
            }

            return errors;
          }}
          decorators={this.state.create ? [decorator] : []}
          initialValues={this.state.initValues}
          onSubmit={this.onSubmit}
          mutators={{ ...arrayMutators }}
          render={({
            handleSubmit,
            values,
            form: {
              mutators: { push },
            },
            submitting,
            pristine,
          }) => (
            <form onSubmit={handleSubmit} className="ui form">
              <div className="field">
                <div className="three required fields">
                  <Field name="name">
                    {({ input, meta }) => (
                      <div className={meta.error && meta.touched ? 'field error' : 'field'}>
                        <label>Contest Name</label>
                        <input {...input} type="text" />
                        {error(meta)}
                      </div>
                    )}
                  </Field>

                  <Field name="kind">
                    {({ input }) => (
                      <div className={`${this.state.create ? '' : 'disabled'} field`}>
                        <label>Contest Type</label>
                        <Field {...input} role="dropDown" component="select">
                          <option value="survive">Survive and Advance</option>
                          <option value="weekly">Player Pick'em</option>
                        </Field>
                      </div>
                    )}
                  </Field>

                  <Field name="season_id">
                    {({ input, meta }) => (
                      <div className={meta.error && meta.touched ? 'field error' : 'field'}>
                        <label>Season name</label>
                        <select {...input} role="dropDown">
                          {this.state.seasons.map((val) => (
                            <option value={val.id} key={val.id}>
                              {val.name}
                            </option>
                          ))}
                        </select>
                        <span>{error(meta)}</span>
                      </div>
                    )}
                  </Field>
                </div>
              </div>

              <Field name="description">
                {({ input, meta }) => (
                  <div className={meta.error && meta.touched ? 'field error' : 'field'}>
                    <label>Description</label>
                    <textarea {...input} type="text" />
                    {error(meta)}
                  </div>
                )}
              </Field>

              <Field name="how_to_play">
                {({ input, meta }) => (
                  <div className={meta.error && meta.touched ? 'field error' : 'field'}>
                    <label>How To Play</label>
                    <textarea {...input} type="text" />
                    {error(meta)}
                  </div>
                )}
              </Field>

              <Field name="image">
                {({ input, meta }) => (
                  <div className="two fields">
                    <div className={meta.error && meta.touched ? 'field error' : 'field'}>
                      <label>Cover Image</label>
                      <input
                        id="image"
                        type="file"
                        multiple="false"
                        accept="image/x-png,image/gif,image/jpeg"
                        onChange={(e) => {
                          this.imageUploadHeandler(e.target.files[0]);
                        }}
                      />
                      <span>{error(meta)}</span>
                    </div>
                    <div className="field">{this.showCover()}</div>
                    <div />
                  </div>
                )}
              </Field>

              <div className="ui hidden divider" />
              <div className="ui divider" />
              <div className="ui hidden divider" />

              <div className="field">
                <div className="inline fields">
                  <Field name="entry_cost">
                    {({ input, meta }) => (
                      <div className={meta.error && meta.touched ? 'field required error' : 'required field'}>
                        <label style={{ display: 'block' }}>Entry Cost $</label>
                        <Cleave
                          {...input}
                          options={{
                            numeral: true,
                            numeralThousandsGroupStyle: 'thousand',
                            // prefix: '$',
                          }}
                        />
                        {error(meta)}
                      </div>
                    )}
                  </Field>

                  <div className="field" style={{ paddingTop: '17px' }}>
                    <Field name="excluded_from_season_pass">
                      {({ input }) => (
                        <Checkbox
                          {...input}
                          toggle
                          value={!!input.value}
                          checked={input.value}
                          onChange={(e, { checked }) => input.onChange(checked)}
                          label="Excluded from season pass?"
                        />
                      )}
                    </Field>
                  </div>
                </div>
              </div>

              <div className="two required fields">
                <Field name="participants_max_count">
                  {({ input, meta }) => (
                    <div className={meta.error && meta.touched ? 'field error' : 'field'}>
                      <label>Max players</label>
                      <Cleave
                        {...input}
                        options={{
                          numeral: true,
                          numeralThousandsGroupStyle: 'thousand',
                        }}
                      />
                      <p>{error(meta)}</p>
                    </div>
                  )}
                </Field>
              </div>

              <div className="ui hidden divider" />
              <div className="ui divider" />
              <div className="ui hidden divider" />

              <div className="field">
                <div className={`two required fields ${values.published ? 'disabled' : ''}`}>
                  <Field name="starts_at">
                    {({ input, meta }) => (
                      <div className={meta.error && meta.touched ? 'field error' : 'field'} role="calendar">
                        <label>Starts At</label>
                        <Input
                          {...input}
                          autoComplete="off"
                          onBlur={(e) => {
                            input.onChange(e.target.value);
                          }}
                          value={input.value}
                        />
                        <p>{error(meta)}</p>
                      </div>
                    )}
                  </Field>

                  <Field name="ends_at">
                    {({ input, meta }) => (
                      <div className={meta.error && meta.touched ? 'field error' : 'field'} role="calendar">
                        <label>Ends At</label>
                        <Input
                          {...input}
                          autoComplete="off"
                          onBlur={(e) => {
                            input.onChange(e.target.value);
                          }}
                          value={input.value}
                        />
                        <p>{error(meta)}</p>
                      </div>
                    )}
                  </Field>
                </div>
              </div>

              <div className="field">
                <div className="two required fields">
                  <Field name="required_amount">
                    {({ input, meta }) => {
                      const collection = values.kind === 'survive' ? requiredAmountSurvive : requiredAmountWeekly;
                      return (
                        <div
                          className={`${meta.error && meta.touched ? 'error' : ''} ${
                            this.state.create ? '' : 'disabled'
                          } field`}
                        >
                          <label>Stats x UserSelections Required</label>
                          <select {...input} className="ui fluid dropdown" role="dropDown">
                            {collection.map((val) => (
                              <option value={val} key={val}>
                                {val}
                              </option>
                            ))}
                          </select>
                          {error(meta)}
                        </div>
                      );
                    }}
                  </Field>
                </div>

                <div className="field">
                  <label>Stat Сategories</label>
                  <FieldArray name="stat_categories">
                    {({ fields }) =>
                      fields.map((name, key) => (
                        <div key={name} className="two fields">
                          <div className="field">
                            <Field
                              className="ui fluid dropdown"
                              component="select"
                              name={`${name}.subject`}
                              placeholder="Subject"
                              defaultValue={values.kind === 'weekly' && this.state.create ? this.state.stats[key] : ''}
                              // role="dropDown"
                            >
                              <option value="" />
                              {this.state.stats.map((item) => (
                                <option value={item} key={item}>
                                  {item}
                                </option>
                              ))}
                            </Field>
                          </div>

                          <div className="field">
                            <Field name={`${name}.amount`} component="input" placeholder="Amount" />
                          </div>
                        </div>
                      ))
                    }
                  </FieldArray>
                </div>
              </div>

              <div className="ui hidden divider" />
              <div className="ui divider" />
              <div className="ui hidden divider" />

              <div className="field">
                <div className="fields" style={{ position: 'relative', marginBottom: '100px' }}>
                  <div className="four wide field">
                    <button type="button" className="ui basic button" onClick={() => push('prizes', '')}>
                      <i className="icon plus" />
                      {' '}
                      Add Prize
                    </button>
                  </div>

                  <div className="twelve wide field">
                    <FieldArray name="prizes">
                      {({ fields }) =>
                        fields.map((name, index) => (
                          <div className="inline fields" key={index}>
                            <div className="fifteen  wide field">
                              <Field name={`${name}.description`} component="input" placeholder="Description" />
                              <Field name={`${name}.priority`} component="input" placeholder="Priority">
                                {({ input, meta }) => (
                                  <div className={meta.error && meta.touched ? 'field error' : 'field'}>
                                    <Cleave
                                      {...input}
                                      placeholder="Priority"
                                      options={{
                                        numeral: true,
                                        numeralThousandsGroupStyle: 'thousand',
                                      }}
                                    />
                                    <p>{error(meta)}</p>
                                  </div>
                                )}
                              </Field>
                            </div>
                            <div className="one wide field">
                              <span
                                onClick={() => {
                                  fields.remove(index);
                                  this.deletePrize(fields.value[index].id);
                                }}
                                style={{ cursor: 'pointer' }}
                              >
                                {' '}
                                ❌
                              </span>
                            </div>
                            <div className="ui segment" style={{ position: 'absolute', left: '7px', top: '30px' }}>
                              <Field name="mystery_memorablia">
                                {({ input }) => (
                                  <Checkbox
                                    {...input}
                                    toggle
                                    value={!!input.value}
                                    checked={input.value}
                                    onChange={(e, { checked }) => input.onChange(checked)}
                                    label="Mystery Memorabilia"
                                  />
                                )}
                              </Field>
                            </div>
                          </div>
                        ))
                      }
                    </FieldArray>
                  </div>
                </div>
              </div>

              <div className="ui segment">
                <Field name="has_cash_prize">
                  {({ input }) => (
                    <Checkbox
                      {...input}
                      toggle
                      value={!!input.value}
                      checked={input.value}
                      onChange={(e, { checked }) => input.onChange(checked)}
                      label="Has Cash Prize"
                    />
                  )}
                </Field>
              </div>

              <div className="two fields">
                <Field name="prize_video_url">
                  {({ input, meta }) => (
                    <div className={`${meta.error && meta.touched ? 'error' : ''} field`}>
                      <label>Prize YouTube url</label>
                      <input {...input} type="text" />
                      {error(meta)}
                    </div>
                  )}
                </Field>
              </div>

              <div className="ui segment">
                <Field name="published">
                  {({ input }) => (
                    <Checkbox
                      {...input}
                      toggle
                      value={!!input.value}
                      checked={input.value}
                      onChange={(e, { checked }) => input.onChange(checked)}
                      label="Published"
                    />
                  )}
                </Field>
              </div>

              <div className="ui hidden divider" />
              <div className="ui divider" />
              <div className="ui hidden divider" />

              <div className="fields">
                <div className="field">
                  <button type="submit" className="ui button" disabled={submitting}>
                    {submitting ? 'Saving…' : 'Save'}
                  </button>
                </div>
              </div>
            </form>
          )}
        />
      </div>
    );
  }
}

export default NewContest;
